// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HJ-H","label":"styles_label__XjQVw"};